import {ActionIcon, Grid, Group} from "@mantine/core";
import {IncrementalDateInput, isDefaultDriverActivityFilter, TicketFilterFormValues} from "@ots-frontend/ots-ui";
import {IconFilter, IconReport, IconSearch} from "@tabler/icons-react";
import {useNavigate} from "react-router-dom";

export type TicketTool = "NEW" | "EDIT"

type TicketToolbarProps = {
  date: Date
  onDateChange: (d: Date) => void
  filter: TicketFilterFormValues,
  onFilterClick: () => void
  onSearchClick: () => void
  isLoading?: boolean
}

export const DriverActivityDayToolbar = (props: TicketToolbarProps) => {
  const {
    date,
    onDateChange,
    filter,
    onFilterClick,
    onSearchClick,
  } = props;

  const navigate = useNavigate();

  return (
    <Grid p="xs">
      <Grid.Col span={4}>
        <Group position="left" align="center">
          <ActionIcon
            variant={!isDefaultDriverActivityFilter(filter) ? "filled" : "subtle"}
            color={!isDefaultDriverActivityFilter(filter) ? "service-work" : undefined}
            onClick={onFilterClick}>
            <IconFilter size="1.125rem"/>
          </ActionIcon>
          <ActionIcon
            variant={"subtle"}
            color={undefined}
            onClick={onSearchClick}>
            <IconSearch size="1.125rem"/>
          </ActionIcon>
          <ActionIcon
            variant={"subtle"}
            color={undefined}
            onClick={() => navigate("/reports/company-transport-services")}>
            <IconReport size="1.125rem"/>
          </ActionIcon>
        </Group>
      </Grid.Col>
      <Grid.Col span={4}>
        <IncrementalDateInput
          defaultValue={date}
          onDateChange={onDateChange}
          popoverProps={{
            withinPortal: true
          }}/>
      </Grid.Col>
      <Grid.Col span={4}>
      </Grid.Col>
    </Grid>
  );
};
